import EmployeeStatus from 'components/Employees/EmployeeStatus';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { Employee } from 'generated/models';

const StatusCell = ({ row: { status } }: ComponentProps<Employee>) => (
  <EmployeeStatus status={status} />
);

export default StatusCell;
